
/*####################################################################################################################
#######################################################################################################################
 
 ##     ## ######## ########   #######      ######  ##       #### ########  ######## ########  
 ##     ## ##       ##     ## ##     ##    ##    ## ##        ##  ##     ## ##       ##     ## 
 ##     ## ##       ##     ## ##     ##    ##       ##        ##  ##     ## ##       ##     ## 
 ######### ######   ########  ##     ##     ######  ##        ##  ##     ## ######   ########  
 ##     ## ##       ##   ##   ##     ##          ## ##        ##  ##     ## ##       ##   ##   
 ##     ## ##       ##    ##  ##     ##    ##    ## ##        ##  ##     ## ##       ##    ##  
 ##     ## ######## ##     ##  #######      ######  ######## #### ########  ######## ##     ## 
 
#######################################################################################################################
#####################################################################################################################*/

import Swiper from 'swiper';
import { Navigation, Pagination, Keyboard } from 'swiper/modules';



// import { Navigation, Pagination, Keyboard, Autoplay, EffectFade } from 'swiper/modules';

var swiper = new Swiper("#event-swiper", {
  modules: [Navigation, Pagination, Keyboard],
  slidesPerView: 1,
  spaceBetween: 0,
  navigation: {
    nextEl: "#event-swiper .swiper-button-next",
    prevEl: "#event-swiper .swiper-button-prev",
  },
  loop: true,
  pagination: {
    el: "#event-swiper .swiper-pagination",
  },
  keyboard: {
    enabled: true,
    onlyInViewport: false
  },
  autoplay: false
});


